// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-activity[data-v-828a4fd4]{background-color:#f8f9fa}.user-activity .table td[data-v-828a4fd4]{border-top-color:#fff}.user-activity .table tr:first-child td[data-v-828a4fd4]{border-top:none}", ""]);
// Exports
module.exports = exports;
